module.exports = __webpack_public_path__ + "media/components/weather-icon/static/daypartcloud-0bdcc320edf422e73d4f836df67f1329.webp";